import { SxProps } from '@mui/material'
import { alpha } from '@mui/material/styles'

import theme from '../../../../../../shared/styles/themes/default.theme'

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  } as SxProps,

  statusCard: (color: string): SxProps => ({
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    background: `linear-gradient(135deg, ${alpha(color, 0.18)}, ${alpha(color, 0.05)})`,
    border: `1px solid ${alpha(color, 0.3)}`,
    boxShadow: '0px 20px 45px rgba(15, 23, 42, 0.08)',
    height: '100%'
  }),

  progressBar: (color: string): SxProps => ({
    mt: theme.spacing(1),
    height: 6,
    borderRadius: 999,
    backgroundColor: alpha(color, 0.2),
    '& .MuiLinearProgress-bar': {
      backgroundColor: color
    }
  }),

  secondaryCard: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2.5),
    border: `1px solid ${theme.palette.grey[200]}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 20px 45px rgba(15, 23, 42, 0.06)',
    height: '100%'
  } as SxProps
}

export default styles
